export default class PageTitleIconComponent {

	constructor() {
		this.template = require('./page.title.icon.view.html');
		this.bindings = {
			iconUrl: '@'
		};
	}
}
PageTitleIconComponent.META = {
	name: 'pageTitleIcon'
};


// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-page-title/page.title.icon.component.js